import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import LockDocumentIcon from 'components/atoms/icons/lock-document';
import { DateFormatter, safeEmpty } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';

import s from './styles.module.scss';

import type { IPatientCallInfo } from 'infrastructure/interfaces';

interface IProps {
  info: IPatientCallInfo;
}

const CallDashboardSaasInfo: React.FC<IProps> = ({ info }) => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <div className={s.infos}>
        <div className={s.info}>
          <p className={s.name}>{info.patientFullName}</p>
          <p className={s.label}>
            {t('labels.dob')}:
            <span>
              {DateFormatter({
                date: info.dob,
                format: DateFormats['MM-dd-yyyy'],
              })}
            </span>
          </p>
          <p className={s.label}>
            {t('labels.primaryPhoneNumber')}:
            <span>{safeEmpty(info.primaryPhoneNumber)}</span>
          </p>
          <p className={s.label}>
            {t('labels.secondaryPhoneNumber')}:
            <span>{safeEmpty(info.secondaryPhoneNumber)}</span>
          </p>
        </div>
        <div className={s.info}>
          <p className={s.label}>
            {t('labels.agency')}:<span>{info.agencyLegalname}</span>
          </p>
          <p className={s.label}>
            {t('labels.agencyPhoneNumber')}:
            <span>{safeEmpty(info.agencyPhoneNumber)}</span>
          </p>
          <p className={s.label}>
            {t('labels.practice')}:<span>{info.practiceFullName}</span>
          </p>
          <p className={s.label}>
            {t('labels.practicePhoneNumber')}:
            <span>{safeEmpty(info.practicePhoneNumber)}</span>
          </p>
          <p className={s.label}>
            {t('labels.practiceWorkNumber')}:
            <span>{safeEmpty(info.practiceWorkNumber)}</span>
          </p>
        </div>
      </div>

      <div className={s.empty}>
        <div className={s['empty-info']}>
          <LockDocumentIcon />
          <p className={s.title}>{t('messages.chartAccessRestricted')}</p>
          <p>
            <Trans
              i18nKey="messages.chartAccessRestrictedMessage"
              components={[<br />, <strong />]}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

export default CallDashboardSaasInfo;
